import React from 'react';
import PropTypes from 'prop-types';

import { SCOPES } from '../../../_shared';

import { ENUMS_VIDEO, MUX_AUTO_GENERATED_LANGUAGES } from '../../constants';
import videoTypes from '../../types';

import MuxStaticUploader from './MuxStaticUploader';

const propTypes = {

	/**
	 * The video which is awaiting upload, if any.
	 */
	video: videoTypes.video,

	/**
	 * The provider for the video. Currently only supports Mux.
	 */
	provider: PropTypes.oneOf([
		ENUMS_VIDEO.PROVIDER.MUX,
	]).isRequired,

	/**
	 * The options for the upload configuration, if any.
	 */
	options: PropTypes.shape({

		/**
		 * The configuration for subtitles to be auto-generated, if any.
		 */
		generated_subtitles: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The BCP 47 language code of the closed caption stream. Defaults to en.
			 */
			language_code: PropTypes.oneOf(
				MUX_AUTO_GENERATED_LANGUAGES
			)

		}))

	}),

	/**
	 * The type of scope for the video.
	 */
	scope: PropTypes.oneOf([
		SCOPES.SESSION,
		SCOPES.ORGANIZATION,
	]).isRequired,

	/**
	 * The scope ID for the video.
	 */
	scopeId: PropTypes.string.isRequired,

	/**
	 * Callback function to execute when a video is created.
	 */
	onCreateVideo: PropTypes.func,

};

/**
 * Component containing a file picker to upload a new
 * video to the library. Handles error and progress state updates.
 *
 * @param {Object} props  The component props.
 * @returns {Object}      The LibraryUploader component.
 */
const LibraryUploader = (props) => {

	const {
		video,
		options,
		provider,
		scope,
		scopeId,
		onCreateVideo,
	} = props;

	if (!provider ||
		!scope ||
		!scopeId
	) { return null; }

	if (provider === ENUMS_VIDEO.PROVIDER.MUX) {
		return (
			<MuxStaticUploader
				video={video}
				scope={scope}
				scopeId={scopeId}
				options={options}
				onCreateVideo={onCreateVideo} />
		);
	}

	return null;

};

LibraryUploader.propTypes = propTypes;

export default LibraryUploader;
